import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import { getCurrency } from '../../../../helpers/currencies'

const formatNumber = (value, currency) => {
  return `${numeral(value).format('0,0.[00]')} ${currency}`
}

const AutomatedTips = ({sales, chartData, rawMaterialCostPct, employeeCostPct}) => {
  const { t } = useTranslation()

  const companyInfo = useSelector((state) => state.company.companyInfo)
  const currency = getCurrency(companyInfo?.currency)

  const data = useMemo(() => {
    return chartData.map(item => {
      const employeesCost = item.employeesMeta.reduce((acc, employee) => {
        return acc + employee.work_duration / 60 * employee.work_cost
      }, 0)
      return {
        ...item,
        employeesCost: employeesCost,
        profit: item.sales - item.productCost - employeesCost,
      }
    }).sort((a, b) => a.profit - b.profit)
  }, [chartData])

  const categoryProfitability = useMemo(() => {
    const categoryMap = sales.reduce((acc, sale) => {
      const categoryName = sale.DishCategory || 'Uncategorized'
      return {
        ...acc,
        [categoryName]: acc[categoryName] ? [...acc[categoryName], sale] : [sale],
      }
    }, {})
    return Object.entries(categoryMap).map(([category, sales]) => {
      const {amount, productCost} = sales.reduce((acc, sale) => {
        return {
          ...acc,
          amount: acc.amount + (sale.DishDiscountSumInt || 0),
          productCost: acc.productCost + (sale['ProductCostBase.ProductCost'] || 0),
        }
      }, {
        amount: 0,
        productCost: 0,
      })
      return {
        name: category,
        margin: amount > 0 ? (amount - productCost) / amount * 100 : 0,
      }
    }).filter(item => item.name).sort((a, b) => b.margin - a.margin)
  }, [sales])

  const [weakestDay] = data
  const [bestCategory] = categoryProfitability
  const [weakestCategory] = categoryProfitability.slice().reverse()

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>{t('Automated tips')}</div>
      </div>
      <div className={styles.tips}>
        <div dangerouslySetInnerHTML={{
          __html: t('Food cost <b>{{foodCost}}</b>, labor cost <b>{{laborCost}}</b>, weakest day: {{date}} · {{profit}}', {
            foodCost: numeral(rawMaterialCostPct).format('0.00') + '%',
            laborCost: numeral(employeeCostPct).format('0.00') + '%',
            date: weakestDay?.originalDate,
            profit: formatNumber(weakestDay?.profit, currency.symbol),
          })
        }} />
        <div dangerouslySetInnerHTML={{
          __html: t('The most profitable category: <b>{{category}}</b> ({{margin}}. Weakest margin: <b>{{weakestCategory}}</b> ({{weakestMargin}}).', {
            category: bestCategory?.name,
            margin: numeral(bestCategory?.margin).format('0.00') + '%',
            weakestCategory: weakestCategory?.name,
            weakestMargin: numeral(weakestCategory?.margin).format('0.00') + '%',
          })
        }} />
      </div>
    </div>
  )
}

export default AutomatedTips